// extracted by mini-css-extract-plugin
module.exports = {"tabsContainer":"BookmarksAndQuickLinks_tabsContainer__pQ8pR","contentContainer":"BookmarksAndQuickLinks_contentContainer__qG9mM"};